import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';
import { IFeedCustomColumnDictionaryItem } from '@/types';
import { usePlatform } from '@/composables/usePlatform';

const platform = usePlatform();

export const feedLiveCustomColumnDictionary = createSimpleDictionary<IFeedCustomColumnDictionaryItem>(
    [
        {
            id: 'position',
            name: 'feed.position',
            subTitle: '',
            isChecked: true,
        },
        {
            id: '1x2',
            name: 'board.1X2Odds',
            subTitle: 'board.market',
            isChecked: true,
        },
        {
            id: 'handicap',
            name: 'board.handicap',
            subTitle: 'board.market',
            isChecked: true,
        },
        {
            id: 'overunder',
            name: 'board.goalHandicap',
            subTitle: 'board.market',
            isChecked: true,
        },
        {
            id: 'bts',
            name: 'board.btts',
            subTitle: 'board.market',
            isChecked: true,
        },
        {
            id: 'dc',
            name: 'board.doubleChance',
            subTitle: 'board.market',
            isChecked: true,
        },
        {
            id: 'f',
            name: 'feed.fouls',
            subTitle: 'board.liveStats',
            isChecked: false,
        },
        {
            id: 'p',
            name: 'feed.possession',
            subTitle: 'board.liveStats',
            isChecked: true,
        },
        {
            id: 'a',
            name: 'feed.attacks',
            subTitle: 'board.liveStats',
            isChecked: true,
        },
        {
            id: 'da',
            name: 'feed.dangerousAttacks',
            subTitle: 'board.liveStats',
            isChecked: true,
        },
        {
            id: 's',
            name: 'feed.shots',
            subTitle: 'board.liveStats',
            isChecked: true,
        },
        {
            id: 'st',
            name: 'feed.shotsOnTarget',
            subTitle: 'board.liveStats',
            isChecked: true,
        },
        {
            id: 'hww',
            name: 'feed.hitWoodwork',
            subTitle: 'board.liveStats',
            isChecked: false,
        },
        {
            id: 'c',
            name: 'feed.corners',
            subTitle: 'board.liveStats',
            isChecked: true,
        },
        {
            id: 'w',
            name: 'board.winPerc',
            subTitle: '',
            isChecked: false,
        },
        {
            id: 'si',
            name: 'feed.gameSituation',
            subTitle: '',
            isChecked: false,
        },
        {
            id: '1X2M%',
            name: 'feed.1x2MarketMargin',
            subTitle: '',
            isChecked: false,
        },
        {
            id: 'hdpM%',
            name: 'feed.handicapMarketMargin',
            subTitle: '',
            isChecked: false,
        },
        {
            id: 'goalM%',
            name: 'feed.goalMarketMargin',
            subTitle: '',
            isChecked: false,
        },
        ...(platform.isAggregator()
            ? [
                  {
                      id: 'feedCount',
                      name: 'feed.feedCount',
                      subTitle: '',
                      isChecked: true,
                  },
              ]
            : []),
    ],
    ['name', 'subTitle']
);
